import { isEqual } from "lodash";

export type TLoadingMoveBookingsAction = {
  type: "move-bookings";
  ids: [number, number];
};

export type TLoadingAddBookingsAction = {
  type: "add-bookings";
  ids: number[];
};

export type TLoadingUpdateBookingAction = {
  type: "update-booking";
  id: number;
};

export type TNewTeeSheetLoadingTeetimeTabAction =
  | TLoadingMoveBookingsAction
  | TLoadingAddBookingsAction
  | TLoadingUpdateBookingAction;

export function loadingTeetimeTabActionsContainsId(actions: TNewTeeSheetLoadingTeetimeTabAction[], id: number) {
  for (const action of actions) {
    switch (action.type) {
      case "move-bookings":
      case "add-bookings":
        if (action.ids.some(actionId => actionId === id)) {
          return true;
        }

        break;
      case "update-booking":
        if (action.id === id) {
          return true;
        }

        break;
    }
  }

  return false;
}

export function loadingTeetimeTabActionsAreEqual(
  firstAction: TNewTeeSheetLoadingTeetimeTabAction,
  secondAction: TNewTeeSheetLoadingTeetimeTabAction,
) {
  if (firstAction.type === "move-bookings" && secondAction.type === "move-bookings") {
    return isEqual(firstAction.ids, secondAction.ids);
  } else if (firstAction.type === "add-bookings" && secondAction.type === "add-bookings") {
    return isEqual(firstAction.ids, secondAction.ids);
  } else if (firstAction.type === "update-booking" && secondAction.type === "update-booking") {
    return firstAction.id === secondAction.id;
  } else {
    return false;
  }
}

export type TLoadingTeetimeTabsActionStatus = "success" | "failure";
